<template>
  <div>
    <div class="msg-item" :key="item.id">
      <div class="flex-row-between-center">
        <div>
          <span class="bold">售后单号：{{ item.number }}</span>
          <span class="c-65">（{{ item.strTag }}）</span>
        </div>

        <div class="flex-row-start-center">
          <el-tag type="danger" v-if="item.processDesc">{{
            item.processDesc
          }}</el-tag>
          <span class="time-out-txt" v-if="item.timeOut">已逾期</span>
          <div v-else>
            <span class="m-l-r-8">距离结束</span>
            <span class="time-item hours">{{ item.hours || "00" }}</span>
            <span class="time-item-point">:</span>
            <span class="time-item minutes">{{ item.minutes || "00" }}</span>
            <span class="time-item-point">:</span>
            <span class="time-item seconds">{{ item.seconds || "00" }}</span>
          </div>
        </div>
      </div>
      <div class="flex-row-between-center m-t-8">
        <div style="width: 500px;">
          <span class="sku-width">SKU：{{ item.ruiguCode }}</span>
          <span
            >商品名称：{{
              item.name && item.name.length > 20
                ? item.name.substring(0, 20) + "..."
                : item.name || "--"
            }}</span
          >
          <div style="margin-top: 4px;">
            <span class="sku-width "
              >售后类型：{{ item.asType | asTypeFilter }}</span
            >
            <span>逾期时间：{{ item.time }}</span>
          </div>
        </div>
        <div class="handle-btn" @click="showDialog">去处理</div>
      </div>
    </div>
    <asOrderDialogVue
      :item="item"
      ref="asDialogRef"
      @closeDialog="closeDialog"
    />
  </div>
</template>
<script>
import asOrderDialogVue from "./asOrderDialog.vue";
export default {
  name: "asOrderItem",
  props: ["item"],
  components: { asOrderDialogVue },
  data() {
    return {};
  },
  filters: {
    asTypeFilter(val) {
      let text = "";
      switch (val) {
        case 1:
          text = "退货";
          break;
        case 3:
          text = "维修";
          break;
        default:
          break;
      }
      return text;
    }
  },
  methods: {
    showDialog() {
      this.$refs.asDialogRef.showDialog();
    },
    closeDialog() {
      this.$emit("closeDialog");
    }
  }
};
</script>
<style lang="scss" scoped>
.msg-item {
  border: 1px solid #e9e9e9;
  padding: 16px;
  margin-bottom: 12px;
  .bold {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }
  .m-t-8 {
    margin-top: 8px;
  }
  .m-l-r-8 {
    margin: 0 8px;
  }
  .m-l-20 {
    margin-left: 20px;
  }
  .sku-width {
    width: 130px;
    display: inline-block;
  }
  .time-item {
    background-color: #f71000;
    color: #fff;
    min-width: 22px;
    display: inline-block;
    text-align: center;
  }
  .time-item-point {
    color: #f71000;
    font-weight: bold;
  }
  .time-out-txt {
    color: #f71000;
    margin-left: 8px;
  }
  .handle-btn {
    color: #ff6224;
    border: 1px solid #ff6224;
    cursor: pointer;
    padding: 4px 11px;
    font-size: 13px;
    border-radius: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pendingOrder/asOrderItem.vue